import { z } from 'zod';
/**
 * Tenant = entidad financiera cliente de Paguz (p. ej. `paguz-demo`).
 * Se deriva **siempre** del token; nunca viaja en la URL ni en el cuerpo. Toda tabla de negocio
 * lleva `tenant_id` y todo repositorio filtra por él.
 * Configuración completa del tenant (`TenantSettings`, adaptadores): `identity/tenant.ts`.
 */
export const TenantCodeSchema = z
    .string()
    .regex(/^[a-z0-9][a-z0-9-]{1,62}$/, 'Código de tenant en minúsculas, números y guiones')
    .meta({ id: 'TenantCode', examples: ['paguz-demo'] });
export const TenantContextSchema = z.object({
    tenantId: z.uuid(),
    tenantCode: TenantCodeSchema,
});
//# sourceMappingURL=tenant.js.map